import {
  i
} from "./chunk.775UL347.js";

// src/components/icons/jb-close-icon/jb-close-icon.css.ts
var jb_close_icon_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}svg{cursor:pointer;display:inline-block;fill:currentcolor;height:var(--icon-size, 29px);transform:scale(1);transition:transform .3s linear;width:var(--icon-size, 30px)}svg:hover{transform:scale3d(0.8, 0.8, 1);transition:transform .3s linear}@media(forced-colors: active){svg{fill:CanvasText}}`;

export {
  jb_close_icon_css_default
};
